<template>
  <div
    v-if="isShowingMessage"
    class="flex message-wrapper"
    :class="{ 'flex-right': isFromSubscriber, 'new-message': message.new === true, 'open-chat-wrapper': isShowingOpenChat }"
  >
    <template v-if="isShowingLeftAvatarPlaceholder">
      <div
        v-if="isShowingLeftAvatar"
        class="message-avatar-placeholder"
      >
        <customer-avatar class="is-small message-avatar" />
      </div>
      <div
        v-else
        class="message-avatar-placeholder"
      />
    </template>

    <component
      :is="messageTypeComponent"
      v-if="Boolean(messageTypeComponent)"
      :message="message"
    />
  </div>
</template>

<script>
// @flow

import { mapState, mapGetters } from 'vuex'
import './message-item.scss'

import CustomerAvatar from '../CustomerAvatar/CustomerAvatar.vue'
import {
  UserInputMessage,
  ImageMessage,
  LoadingMessage,
  VideoMessage,
  GalleryMessage,
  ProductsMessage,
  TextMessage,
  LiveChat,
  UploadMessage
} from '../MessageTypes'

import { isRequestInputMessage } from '../../models'

export default {
  components: {
    CustomerAvatar,
    UserInputMessage,
    TextMessage,
    ImageMessage,
    VideoMessage,
    GalleryMessage,
    ProductsMessage,
    LoadingMessage,
    LiveChat,
    UploadMessage
  },
  props: {
    message: { // ChatBubbleMessage<any>
      default: () => {
        return {}
      },
      type: Object
    },
    messageGroup: {
      default: () => [],
      type: Array
    },
    isLastMessageGroup: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    ...mapState(['customerId', 'messages']),
    ...mapGetters(['avatarImage', 'isShowingOpenChat']),
    isFromSubscriber () {
      return this.customerId === this.message.to
    },
    isShowingLeftAvatarPlaceholder () {
      if (this.isShowingOpenChat) return false
      if (this.messageTypeComponent === 'GalleryMessage') return false
      if (this.messageTypeComponent === 'ProductsMessage') return false
      if (this.messageTypeComponent === 'LoadingIndicator') return false
      if (this.messageTypeComponent === 'UploadMessage') return false

      return Boolean(this.messageTypeComponent) && !this.isFromSubscriber
    },
    isShowingLeftAvatar (): boolean {
      const messageGroup = this.messageGroup.filter(m => m.type !== 'loading')
      const lastMessageInGroup = (this.message.id === messageGroup[messageGroup.length - 1].id)
      const hasUploadMessage = messageGroup.some(m => m.type === 'upload')

      return ((lastMessageInGroup || hasUploadMessage) && !(this.isLastMessageGroup && this.messages.isShowingTypingIndicator))
    },
    isShowingMessage (): boolean {
      if (this.message.type === 'live_chat') {
        return this.isLastMessageGroup
      }

      return true
    },
    messageTypeComponent () {
      if (this.message.type === 'message') {
        return 'TextMessage'
      } else if (this.message.type === 'image') {
        return 'ImageMessage'
      } else if (this.message.type === 'video') {
        return 'VideoMessage'
      } else if (isRequestInputMessage(this.message)) {
        return 'UserInputMessage'
      } else if (this.message.type === 'gallery') {
        return 'GalleryMessage'
      } else if (this.message.type === 'products') {
        return 'ProductsMessage'
      } else if (this.message.type === 'loading') {
        return 'LoadingMessage'
      } else if (this.message.type === 'live_chat') {
        return 'LiveChat'
      } else if (this.message.type === 'upload') {
        return 'UploadMessage'
      } else {
        return null
      }
    }
  }
}
</script>
